import {
  CSSProperties,
  DetailedHTMLProps,
  DOMAttributes,
  ElementType,
  HTMLAttributes,
} from 'react';

import PropTypes, { Validator } from 'prop-types';
import { CSSProp } from 'styled-components';

export const asPropType = PropTypes.oneOfType([
  PropTypes.string,
  PropTypes.elementType,
]) as Validator<ElementType>;

export const stylePropType = PropTypes.oneOfType([
  PropTypes.string,
  PropTypes.object,
  PropTypes.array,
]) as Validator<CSSProp>;

export type StylableComponent<
  Tag,
  Attributes extends DOMAttributes<Tag> = HTMLAttributes<Tag>
> = Omit<Attributes, 'style' | 'css'> & {
  as?: ElementType;
  style?: CSSProp | null;
};

export type DetailedStylableComponent<
  Attributes,
  Tag,
  DetailedAttributes = DetailedHTMLProps<Attributes, Tag>
> = Omit<DetailedAttributes, 'style' | 'css'> & {
  as?: ElementType;
  style?: CSSProp | null;
};

/**
 * Type used for render props
 *
 * ```typescript
 * type MyComponentProps = StylableComponent<HTMLDivElement> & {
 * renderBody?: (props: StylableRenderPropType) => ReactElement;
 * }
 * ```
 */
export type StylableRenderPropType = { style: CSSProperties };
